import { ProductMode, StorageState, SystemInfo } from '@common/models';

export function shouldShowStorageStateModal(systemInfo: SystemInfo, isBDestinationTabOpened: boolean): boolean {
  const { ProductMode: productMode, StorageState: storageState } = systemInfo;

  const isResaleMode = productMode === ProductMode.Resale;
  const isStorageNotSet = storageState === StorageState.NotSet;

  return !isBDestinationTabOpened && isResaleMode && isStorageNotSet;
}
